export const letterR = {
  nouns: [
    {"room": ["Raum", "Räume", "der", "die", "m"]},
    {"bill": ["Rechnung", "Rechnungen", "die", "die", "f"]},
    {"rain": ["Regen", "Regen", "der", "die", "m"]},
    {"rice": ["Reis", "Reis", "der", "der", "m"]},
    {"trip": ["Reise", "Reisen", "die", "die", "f"]},
    {"travel agency": ["Reisebüro", "Reisebüros", "das", "die", "n"]},
    {"travel guide": ["Reiseführer", "Reiseführer", "der", "die", "m"]},
    {"repair": ["Reparatur", "Reparaturen", "die", "die", "f"]},
    {"restaurant": ["Restaurant", "Restaurants", "das", "die", "n"]},
    {"reception": ["Rezeption", "Rezeptionen", "die", "die", "f"]}
  ],
  verbs: [
    {"to ride a bike": ["Rad fahren", "fahre Rad", "fährst Rad", "fährt Rad", "fährt Rad", "fährt Rad", "fahren Rad", "fahrt Rad", "fahren Rad", "fahren Rad"]},
    {"to smoke": ["rauchen", "rauche", "rauchst", "raucht", "raucht", "raucht", "rauchen", "raucht", "rauchen", "rauchen"]},
    {"to rain": ["regnen", "regne", "regnst", "regnet", "regnet", "regnet", "regnen", "regnet", "regnen", "regnen"]},
    {"to travel": ["reisen", "reise", "reist", "reist", "reist", "reist", "reisen", "reist", "reisen", "reisen"]},
    {"to repair": ["reparieren", "repariere", "reparierst", "repariert", "repariert", "repariert", "reparieren", "repariert", "reparieren", "reparieren"]},
    {"to call": ["rufen", "rufe", "rufst", "ruft", "ruft", "ruft", "rufen", "ruft", "rufen", "rufen"]},
    {"to run": ["rennen", "renne", "rennst", "rennt", "rennt", "rennt", "rennen", "rennt", "rennen", "rennen"]},
    {"to rain": ["regnen", "regne", "regnest", "regnet", "regnet", "regnet", "regnen", "regnet", "regnen", "regnen"]},
    {"to smell": ["riechen", "rieche", "riechst", "riecht", "riecht", "riecht", "riechen", "riecht", "riechen", "riechen"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Raum ist groß.',
        english: 'The room is large.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Rechnung ist teuer.',
        english: 'The bill is expensive.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Regen fällt.',
        english: 'The rain is falling.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Reise ist schön.',
        english: 'The trip is beautiful.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Restaurant ist voll.',
        english: 'The restaurant is full.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Rezeption ist offen.',
        english: 'The reception is open.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Reiseführer spricht.',
        english: 'The travel guide speaks.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Reparatur ist fertig.',
        english: 'The repair is finished.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Reisebüro hilft.',
        english: 'The travel agency helps.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Reis ist gut.',
        english: 'The rice is good.',
        answer: 'Der',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Raum.',
        english: 'I see the room.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie bezahlt ___ Rechnung.',
        english: 'She pays the bill.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Reis.',
        english: 'He needs the rice.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir machen ___ Reise.',
        english: 'We make the trip.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du besuchst ___ Restaurant.',
        english: 'You visit the restaurant.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich rieche ___ Regen.',
        english: 'I smell the rain.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie findet ___ Rezeption.',
        english: 'She finds the reception.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er liest ___ Reiseführer.',
        english: 'He reads the travel guide.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir brauchen ___ Reparatur.',
        english: 'We need the repair.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du suchst ___ Reisebüro.',
        english: 'You search for the travel agency.',
        answer: 'das',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Reiseführer.',
        english: 'I help the travel guide.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie geht zu ___ Rezeption.',
        english: 'She goes to the reception.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Reisebüro.',
        english: 'He speaks with the travel agency.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir sitzen in ___ Raum.',
        english: 'We sit in the room.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du arbeitest für ___ Reparatur.',
        english: 'You work for the repair.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Ich komme aus ___ Restaurant.',
        english: 'I come from the restaurant.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie dankt ___ Reiseführer.',
        english: 'She thanks the travel guide.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er lebt bei ___ Reisebüro.',
        english: 'He lives near the travel agency.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir warten auf ___ Regen.',
        english: 'We wait for the rain.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Rezeption.',
        english: 'You go to the reception.',
        answer: 'der',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The room is large.',
        german: ['Der Raum ist groß.', 'Das Zimmer ist groß.'],
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She pays the bill.',
        german: 'Sie bezahlt die Rechnung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the travel guide.',
        german: 'Ich helfe dem Reiseführer.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The rain falls heavily.',
        german: 'Der Regen fällt stark.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We make the trip.',
        german: 'Wir machen die Reise.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The restaurant is full.',
        german: 'Das Restaurant ist voll.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She finds the reception.',
        german: 'Sie findet die Rezeption.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He repairs the machine.',
        german: 'Er repariert die Maschine.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I buy the rice.',
        german: 'Ich kaufe den Reis.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The travel agency helps.',
        german: 'Das Reisebüro hilft.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You smell the rain.',
        german: 'Du riechst den Regen.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The rice is good.',
        german: 'Der Reis ist gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We travel to Berlin.',
        german: 'Wir reisen nach Berlin.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She smokes a cigarette.',
        german: 'Sie raucht eine Zigarette.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He reads the travel guide.',
        german: 'Er liest den Reiseführer.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The reception is closed.',
        german: 'Die Rezeption ist geschlossen.',
        type: 'translation',
        caseType: 'nominative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to travel" for "I"?',
        answer: 'reise',
        verb: 'reisen',
        verbEnglish: 'to travel',
        subject: 'ich',
        conjugation: 'reise'
      },
      {
        question: 'How do you conjugate "to repair" for "you" (informal)?',
        answer: 'reparierst',
        verb: 'reparieren',
        verbEnglish: 'to repair',
        subject: 'du',
        conjugation: 'reparierst'
      },
      {
        question: 'How do you conjugate "to smoke" for "he"?',
        answer: 'raucht',
        verb: 'rauchen',
        verbEnglish: 'to smoke',
        subject: 'er',
        conjugation: 'raucht'
      },
      {
        question: 'What is the simple past of "to travel" for "she"?',
        answer: 'reiste',
        verb: 'reisen',
        verbEnglish: 'to travel',
        subject: 'sie',
        conjugation: 'reiste'
      },
      {
        question: 'What is the simple past of "to repair" for "we"?',
        answer: 'reparierten',
        verb: 'reparieren',
        verbEnglish: 'to repair',
        subject: 'wir',
        conjugation: 'reparierten'
      },
      {
        question: 'What is the simple past of "to smoke" for "they"?',
        answer: 'rauchten',
        verb: 'rauchen',
        verbEnglish: 'to smoke',
        subject: 'sie',
        conjugation: 'rauchten'
      },
      {
        question: 'How do you conjugate "to rain" for "I"?',
        answer: 'regne',
        verb: 'regnen',
        verbEnglish: 'to rain',
        subject: 'ich',
        conjugation: 'regne'
      },
      {
        question: 'What is the simple past of "to ride a bike" for "she"?',
        answer: 'fuhr Rad',
        verb: 'Rad fahren',
        verbEnglish: 'to ride a bike',
        subject: 'sie',
        conjugation: 'fuhr Rad'
      },
      {
        question: 'How do you conjugate "to smell" for "we"?',
        answer: 'riechen',
        verb: 'riechen',
        verbEnglish: 'to smell',
        subject: 'wir',
        conjugation: 'riechen'
      }
    ]
  }
}
